import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _createTraceableTraderRequest = { traceableTrader: '_traceableTrader' };
var _createTraceableTraderResponse = { traceableTrader: '_traceableTrader' };
var _getPublicTraceableTraderRequest = {};
var _getPublicTraceableTraderResponse = {
    traceableTrader: '_traceableTrader',
};
var _getTraceableTraderRequest = {};
var _getTraceableTraderResponse = { traceableTrader: '_traceableTrader' };
var _traceableTrader = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    validationDate: 'google.protobuf.Timestamp',
    businessAddress: '_address',
};
var _updateTraceableTraderRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    traceableTrader: '_traceableTrader',
};
var _updateTraceableTraderResponse = { traceableTrader: '_traceableTrader' };
function resolveWixPartnersTraceabilityV1TradersTraceabilityUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/traceable-traders',
                destPath: '/api',
            },
            {
                srcPath: '/v1/traceable-traders',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/traceable-traders',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/traceable-traders',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/traceable-traders',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/traceable-traders',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/traceable-traders',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a TraceableTrader. */
export function createTraceableTrader(payload) {
    var _a = serializer(_createTraceableTraderRequest, { _address: _address, _addressLocation: _addressLocation, _traceableTrader: _traceableTrader }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTraceableTraderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _traceableTrader: _traceableTrader,
    }).fromJSON;
    function __createTraceableTrader(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.partners.traceability.v1.traceable_trader',
            method: 'POST',
            methodFqn: 'wix.partners.traceability.v1.TradersTraceability.CreateTraceableTrader',
            url: resolveWixPartnersTraceabilityV1TradersTraceabilityUrl({
                protoPath: '/v1/traceable-trader',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTraceableTrader.fromReq = fromReq;
    __createTraceableTrader.__isAmbassador = true;
    return __createTraceableTrader;
}
/** Retrieves a TraceableTrader. */
export function getTraceableTrader(payload) {
    var _a = serializer(_getTraceableTraderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTraceableTraderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _traceableTrader: _traceableTrader,
    }).fromJSON;
    function __getTraceableTrader(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.partners.traceability.v1.traceable_trader',
            method: 'GET',
            methodFqn: 'wix.partners.traceability.v1.TradersTraceability.GetTraceableTrader',
            url: resolveWixPartnersTraceabilityV1TradersTraceabilityUrl({
                protoPath: '/v1/traceable-trader/{traceableTraderId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTraceableTrader.fromReq = fromReq;
    __getTraceableTrader.__isAmbassador = true;
    return __getTraceableTrader;
}
/** Retrieves a PublicTraceableTrader. */
export function getPublicTraceableTrader(payload) {
    var _a = serializer(_getPublicTraceableTraderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPublicTraceableTraderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _traceableTrader: _traceableTrader,
    }).fromJSON;
    function __getPublicTraceableTrader(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.partners.traceability.v1.traceable_trader',
            method: 'GET',
            methodFqn: 'wix.partners.traceability.v1.TradersTraceability.GetPublicTraceableTrader',
            url: resolveWixPartnersTraceabilityV1TradersTraceabilityUrl({
                protoPath: '/v1/traceable-trader/{publicTraceableTraderId}/public',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPublicTraceableTrader.fromReq = fromReq;
    __getPublicTraceableTrader.__isAmbassador = true;
    return __getPublicTraceableTrader;
}
/**
 * Updates a TraceableTrader.
 *
 *
 * Each time the TraceableTrader is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the TraceableTrader.
 * This ensures you're working with the latest TraceableTrader
 * and prevents unintended overwrites.
 */
export function updateTraceableTrader(payload) {
    var _a = serializer(_updateTraceableTraderRequest, { _address: _address, _addressLocation: _addressLocation, _traceableTrader: _traceableTrader }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTraceableTraderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _traceableTrader: _traceableTrader,
    }).fromJSON;
    function __updateTraceableTrader(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.partners.traceability.v1.traceable_trader',
            method: 'PATCH',
            methodFqn: 'wix.partners.traceability.v1.TradersTraceability.UpdateTraceableTrader',
            url: resolveWixPartnersTraceabilityV1TradersTraceabilityUrl({
                protoPath: '/v1/traceable-trader',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTraceableTrader.fromReq = fromReq;
    __updateTraceableTrader.__isAmbassador = true;
    return __updateTraceableTrader;
}
//# sourceMappingURL=http.impl.js.map